var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "M18 15.38c0 .306-.064.621-.2.927a3.5 3.5 0 0 1-.545.867c-.393.459-.825.79-1.314 1.003a3.8 3.8 0 0 1-1.562.323q-1.229.002-2.612-.62a14 14 0 0 1-2.756-1.683 23.5 23.5 0 0 1-2.628-2.38 24 24 0 0 1-2.236-2.78c-.657-.969-1.186-1.938-1.57-2.899Q2 6.687 2 5.36c0-.578.096-1.13.288-1.64.193-.519.497-.995.922-1.42.513-.535 1.073-.799 1.666-.799.225 0 .449.051.65.153.208.102.392.255.536.476l1.859 2.78c.144.212.248.407.32.595.072.178.113.357.113.518 0 .204-.057.408-.169.603-.104.196-.256.4-.448.604l-.61.672A.47.47 0 0 0 7 8.24c0 .068.008.127.024.195.024.068.048.119.064.17.144.28.392.646.745 1.088q.539.665 1.161 1.343c.433.45.85.867 1.274 1.25.417.373.761.628 1.034.781q.06.028.144.069a.5.5 0 0 0 .2.034c.137 0 .24-.051.329-.145l.609-.637q.3-.321.577-.476c.184-.12.368-.179.569-.179.152 0 .312.034.488.11.177.077.36.188.561.332l2.652 1.998q.311.226.44.543c.08.213.129.425.129.663"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff",
    rx: 5.714
  })))));
};
export default SvgPhone;